import { IDropdownOption } from '@fluentui/react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { parseInputNumber } from '../../../../NumberField';
import { actions, createFormSelector } from '../../../slice';
import { Product } from '../../../slice/newFormReducers';

export const useColumnSelector = <T extends keyof Product>(
  uuid: string,
  key: T
): Product[T] | undefined => {
  const selector = useMemo(
    () =>
      createFormSelector(
        (state) => state.products,
        (products) => products?.[uuid]?.[key]
      ),
    [uuid, key]
  );

  return useSelector(selector);
};

export const useColumnOnChangeFn = (
  uuid: string,
  key: keyof Product,
  toNumber?: boolean
) => {
  return useMemo(
    () => (_: any, newValue?: string | number | IDropdownOption | boolean) => {
      if (typeof newValue === "object") newValue = newValue.key;

      if (toNumber && typeof newValue === "string")
        newValue = parseInputNumber(newValue);

      actions.setFormProductVariable([uuid, key, newValue]);
    },
    [uuid, key]
  );
};
